export default function CheckMark({
  stroke = 'currentColor',
  hover = 'transform group-hover:translate-x-0.8  ',
  transition = 'transition-all duration-300 ease-out',
}: {
  stroke?: string;
  hover?: string;
  transition?: string;
}) {
  return (
    <div className={`${transition} ${hover}`}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 9.11111L5.48613 12.7943C5.87856 13.3756 6.73198 13.3829 7.13422 12.8083L14 3"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
}
